import React from "react";
import { Card, bboxShort, cropUrl } from "./primitives";

/** Isolamento visivo di una discrepanza FASE A (es. PDF-017 asola: disegno 55 vs FASE A 65) senza alterare alcun risultato. */
export const DiscrepancyCard = ({ discrepancies }) => {
  if (!discrepancies?.length) return null;
  return (
    <div id="cl-discrepancy">
      {discrepancies.map((r) => {
        const ev = (r.evidence || []).find((e) => e.bbox_pct) || (r.evidence || [])[0];
        return (
          <Card key={`${r.case_id}-${r.idx}`} title={`Discrepanza FASE A — ${r.case_id} · ${r.campo}`} subtitle="Il lettore coincide con la quota del disegno; la FASE A riporta un valore diverso. Il ritaglio serve solo alla discussione tecnica: nessun verdetto è stato modificato." testId={`cl-discrepancy-${r.case_id}`} tone="border-tech-300">
            <div className="grid gap-3 md:grid-cols-[minmax(0,3fr)_minmax(0,2fr)]">
              <div className="border border-border bg-white overflow-auto max-h-[420px]">
                {ev ? <img src={cropUrl(r.case_id, ev, 220)} alt={`ritaglio ${r.case_id} ${r.campo}`} className="max-w-full" data-testid={`cl-discrepancy-crop-${r.case_id}`} /> : <div className="p-3 text-muted-foreground">Nessuna evidenza con bbox.</div>}
              </div>
              <div className="space-y-1">
                <div><span className="text-muted-foreground">FASE A:</span> <b data-testid="cl-discrepancy-fase-a">{r.fase_a}</b></div>
                <div><span className="text-muted-foreground">Lettore (primo risultato congelato):</span> <b data-testid="cl-discrepancy-reader">{r.lettore}</b></div>
                <div className="text-muted-foreground">{r.nota}</div>
                {ev && <div className="text-[10px] text-muted-foreground">Evidenza {ev.segment_id}:{ev.evidence_id} · pagina {ev.page} · bbox {bboxShort(ev.bbox_pct)} · testo letto: «{ev.text}»</div>}
                {(r.revisions || []).map((v, i) => <div key={i} className="text-[10px]">Rilettura {v.revision_id}: «{v.lettore}» → {v.esito}</div>)}
                <div className="text-[10px] text-tech-800 font-bold">Da verificare da parte del tecnico sul disegno: il verdetto resta DISCREPANZA_FASE_A (non conteggiato né come errore del lettore né come corretto).</div>
              </div>
            </div>
          </Card>
        );
      })}
    </div>
  );
};
